import { CommonModule, NgFor, NgIf } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators
} from '@angular/forms'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { Store } from '@ngrx/store'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastrService } from 'ngx-toastr'
import { combineLatest, forkJoin, Observable, Subject, take, takeUntil } from 'rxjs'
import { User, UserBusinesses } from '../../../../store/auth/auth.state'
import { selectUser } from '../../../../store/auth/auth.selectors'
import { LeavePolicyService } from '../../../../services/leave-policy.service'
import { UserService } from '../../../../services/user.service'
import { loadEmployees } from '../../../../store/user/user.actions'
import { loadBusinesses } from '../../../../store/business/business.actions'
import { Business } from '../../../../store/business/business.state'
import { selectAllBusinesses } from '../../../../store/business/business.selectors'
import { RouterModule } from '@angular/router'
import { eps } from '../../../../services/url.service'
import { NgSelectModule } from '@ng-select/ng-select'
import { LeavePolicy, LeaveType } from '../../../../store/leave-policy/leave-policy.state'
import { UtilsService } from '../../../../services/utils.service'
import { Actions, ofType } from '@ngrx/effects'
import { SharedModule } from '../../../../shared/shared.module'

// export enum LeaveType {
//   // eslint-disable-next-line @typescript-eslint/naming-convention
//   LeaveWithoutPay = 'Leave Without Pay',
//   // eslint-disable-next-line @typescript-eslint/naming-convention
//   Casual = 'Casual Leave',
//   // eslint-disable-next-line @typescript-eslint/naming-convention
//   Sick = 'Sick Leave'
// }
// export enum LeaveType {
//   LEAVEWITHOUTPAY = 'Leave Without Pay',
//   CASUAL = 'Casual Leave',
//   SICK = 'Sick Leave',
//   MATERNITY = 'Maternity Leave',
//   PATERNITY = 'Paternity Leave',
//   BEREAVEMENT = 'Bereavement Leave', //Taken to attend the funeral or recover from the death of a close relative.
//   COMPOFF = 'Compensatory Off',
//   MARRIAGE = 'Marriage Leave',
//   PL = 'Privilege Leave', //A type of paid leave accrued by employees based on their length of service, often taken for vacations or personal time off.
//   RELIGIOUSFESTIVAL = 'Religious Festival Leave', //Leave granted to employees to observe their religious festivals.
//   STUDY = 'Study Leave', //A type of leave granted to employees to pursue further education or training.
//   SABBATICAL = 'Sabbatical Leave', // A longer period of unpaid leave (often months or a year) for personal development, travel, or other purposes.
//   FLOATER = 'Floater Leave' //A "floater leave," also known as a floating holiday or floating day, is a paid day off that employees can use at their own discretion, often outside of the standard public holidays. Unlike fixed holidays, employees choose when they take these days off, allowing for flexibility and the ability to accommodate individual needs or preferences.
// }

// export interface LeavePolicy {
//   id: string
//   title: string
//   description: string
//   leaveType: LeaveType
//   date: string
//   disabled: boolean
//   businessId: string
//   business: Business
//   encashable: boolean

//   accrualMethod: string
//   totalPerYear: number
//   accrualFrequency: string
//   accrualHappenPeriod: boolean
//   isProbationPeriod: boolean
//   probationPeriodLength: number
//   maxLeaveBalanceCap: boolean
//   accruedProRataBasis: boolean

//   resetHappen: string
//   resetStart: string
//   resetHappenPeriod: boolean
//   leavesCarryForward: number
//   futureResetCycle: boolean

//   leaveAdvanceNoticePeriod: boolean
//   leaveAdvanceNoticePeriodDay: number
//   isHalfDay: boolean
//   isQuarterDay: boolean
//   maxConsecutiveLeaves: number
//   isHolidayExcluded: boolean
//   isWeekendExcluded: boolean
//   isNagativeBalanceAllowed: boolean
//   leaveTypeExclude: string[]
// }

@Component({
  selector: 'app-leave-policies',
  imports: [
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CapitalizePipe,
    HasPermissionDirective,
    PaginationComponent,
    RouterModule,
    NgSelectModule,
    SharedModule
  ],
  templateUrl: './leave-policies.component.html',
  styleUrl: './leave-policies.component.scss'
})
export class LeavePoliciesComponent implements OnInit {
  private store = inject(Store)
  private leavePolicyService = inject(LeavePolicyService)
  private userService = inject(UserService)
  private modalService = inject(NgbModal)
  private fb = inject(FormBuilder)
  // toastr = inject(ToastrService)
  form!: FormGroup
  updateform!: FormGroup
  assignLeavePolicyform!: FormGroup
  policyList: LeavePolicy[] = []
  public totalCount = 0
  public currentPage = 1
  public pageLimit = 10
  public search = ''
  public order = 'desc'
  public isArchived = false
  public businessId!: string
  businessList: UserBusinesses[] | undefined = []
  DeleteId!: string
  blockUnblockId!: string
  blockUnblockStatus!: string
  blockTilte!: string
  editPolicy: LeavePolicy | null = null
  selectedBusiness: any = null

  leaveTypeEnum = LeaveType // Make the enum accessible in the template
  public employeeList: User[] = []
  user: User | null = null
  selectedBusinessOwner = ''
  pageLastRecord = 0
  businessIdss!: string[]
  businesses$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  selectedBusinessId = ''
  leaveTypes = Object.values(LeaveType) // Get an array of the enum values for iteration
  currentStep = 1
  steps = [1, 2, 3, 4] // Steps for the form
  isLoading = false
  private destroyed$ = new Subject<void>()
  minDate: string = '' // must be a string in yyyy-mm-dd format
  modalPolicyList: LeavePolicy[] = []
  hideOtherFields = false

  constructor(
    private toastr: ToastrService,
    private utilsService: UtilsService,
    private actions$: Actions
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectUser)
      .pipe(take(1))
      .subscribe(user => {
        this.user = user
        if (user && this.isAdmin()) {
          // this.loadAllBusinesses()
          this.getLeavePolicyList()
        }
        const businessIds = user?.businessIds // your array of business IDs
        if (businessIds && businessIds.length) {
          this.businessIdss = businessIds
          // const paramString = `businessIds=${businessIds.join(',')}`
          // this.store.dispatch(loadBusinesses({ params: paramString }))
        }
        // this.selectedBusiness = user?.business?.id

        this.businessList = user?.businesses
        //if (this.user?.role.name === 'Business Owner') {
        //  this.selectedBusinessOwner = this.user.businessOwnerId
        //}
        this.getLeavePolicyList()
      })
    // this.userService
    //   .getUsers()
    //   .pipe(take(1))
    //   .subscribe(employeeList => {
    //     this.employeeList = employeeList.users
    //   })
    this.loadAllBusinesses()
    this.loadEmployees()
    this.initializeForm()

    this.assignLeavePolicyform = this.fb.group({
      // employeeIds: this.fb.array([], Validators.required), // Example validators
      employeeIds: [[], Validators.required], // ← Change here to FormControl
      leavePolicyId: ['', [Validators.required]], // Example validators
      businessId: ['', Validators.required]
    })

    this.businesses$.subscribe(businesses => {
      if (businesses.length === 1) {
        this.form.get('businessId')?.setValue(businesses[0].id)
        this.selectedBusinessId = businesses[0].id
        this.selectedBusiness = businesses[0].id
        // this.onBusinessChange(businesses[0].id)
        this.getLeavePolicyList()
      }
    })

    combineLatest([
      this.businesses$, // Observable<Business[]>
      this.form.get('businessId')!.valueChanges // Observable<any>
    ]).subscribe(([businesses, id]) => {
      const selected = businesses.find((b: Business) => b.id === id)

      if (selected?.incorporationDate) {
        this.minDate = this.formatDateToYYYYMMDD(selected.incorporationDate)
        // console.log('incorporation date', this.minDate)
        const currentDate = this.form.get('date')?.value
        if (currentDate && currentDate < this.minDate) {
          this.form.get('date')?.setValue('')
        }
      }
    })

    // this.form.get('leaveType')?.valueChanges.subscribe((value: string) => {
    //   if (value === this.leaveTypeEnum.COMPOFF) {
    //     // Hide irrelevant fields
    //     this.hideOtherFields = true

    //     // Set default values
    //     this.form.patchValue({
    //       accrualMethod: 'Unlimited',
    //       totalPerYear: 0
    //     })

    //     this.form.get('accrualMethod')?.setValue('Unlimited')
    //     this.form.get('totalPerYear')?.setValue(0)

    //     // Optionally disable the fields so user can't edit
    //     this.form.get('accrualMethod')?.disable()
    //     this.form.get('totalPerYear')?.disable()
    //   } else {
    //     this.hideOtherFields = false

    //     // Enable the fields again
    //     this.form.get('accrualMethod')?.setValue('Throughout Every Period')
    //     this.form.get('accrualMethod')?.enable()
    //     this.form.get('totalPerYear')?.enable()
    //   }
    // })
  }

  private attachLeaveTypeWatcher(): void {
    this.form.get('leaveType')?.valueChanges.subscribe((value: string) => {
      if (value === this.leaveTypeEnum.COMPOFF || value === this.leaveTypeEnum.LEAVEWITHOUTPAY) {
        this.hideOtherFields = true
        this.form.get('accrualMethod')?.setValue('Unlimited')
        // this.form.get('accrualMethod')?.disable()
        this.form.get('accrualMethod')?.enable()
        this.form.get('totalPerYear')?.setValue(0)
        // this.form.get('totalPerYear')?.disable()
        this.form.get('totalPerYear')?.enable()
      } else {
        this.hideOtherFields = false
        this.form.get('accrualMethod')?.setValue('Throughout Every Period')
        this.form.get('accrualMethod')?.enable()
        this.form.get('totalPerYear')?.enable()
      }
    })

    this.form.get('accrualMethod')?.valueChanges.subscribe((method: string) => {
      const type = this.form.get('leaveType')?.value
      if (type === this.leaveTypeEnum.COMPOFF || type === this.leaveTypeEnum.LEAVEWITHOUTPAY) {
        this.hideOtherFields = method === 'Unlimited'
        if (method === 'Unlimited') {
          //   this.form.get('totalPerYear')?.disable()
          // } else {
          this.form.get('totalPerYear')?.enable()
        }
      }
    })

    this.updateform.get('accrualMethod')?.valueChanges.subscribe((method: string) => {
      const type = this.updateform.get('leaveType')?.value
      if (type === this.leaveTypeEnum.COMPOFF || type === this.leaveTypeEnum.LEAVEWITHOUTPAY) {
        this.hideOtherFields = method === 'Unlimited'
      }
    })
  }

  initializeForm() {
    // this.form = this.fb.group({
    //   title: ['', [Validators.required]], // Example validators
    //   date: ['', [Validators.required]], // Example validators
    //   description: [''], // Example validators
    //   leaveType: ['', Validators.required],
    //   disabled: [false],
    //   businessId: ['', Validators.required],
    //   effectiveFrom: [''],
    //   encashable: ['']
    // })

    this.form = this.fb.group(
      {
        title: ['', [Validators.required]], // Example validators
        date: ['', [Validators.required]], // Example validators
        description: [''], // Example validators
        leaveType: ['', Validators.required],
        disabled: [false],
        businessId: ['', Validators.required],
        // effectiveFrom: ['', Validators.required],
        encashable: [false, Validators.required],

        accrualMethod: ['Throughout Every Period', Validators.required],
        totalPerYear: [0, [Validators.max(365), Validators.min(0)]],
        accrualFrequency: ['Annually'],
        accrualHappenPeriod: [false],
        isProbationPeriod: [false],
        probationPeriodLength: [0, [Validators.required, Validators.min(0)]],
        maxLeaveBalanceCap: [0, [Validators.required, Validators.min(0), Validators.max(365)]],
        IsMaxLeaveBalanceCap: [false],
        accruedProRataBasis: [false],
        proRataBasisDays: [0, [Validators.required, Validators.max(365), Validators.min(0)]],
        // maxLeaveBalance: [0, [Validators.min(0), Validators.max(365)]],

        resetHappen: ['Annually', Validators.required],
        resetStart: ['January', Validators.required],
        resetHappenPeriod: [true, Validators.required],
        leavesCarryForward: [0, [Validators.required, Validators.max(365), Validators.min(0)]],
        futureResetCycle: [false, Validators.required],

        leaveAdvanceNoticePeriod: [false, Validators.required],
        leaveAdvanceNoticePeriodDay: [
          0,
          [Validators.required, Validators.max(365), Validators.min(0)]
        ],
        isHalfDay: [false, Validators.required],
        isQuarterDay: [false, Validators.required],
        maxConsecutiveLeaves: [0, [Validators.required, Validators.max(365), Validators.min(0)]],
        isHolidayExcluded: [false, Validators.required],
        isWeekendExcluded: [false, Validators.required],
        isNagativeBalanceAllowed: [false, Validators.required],
        leaveTypeExclude: this.fb.control([])
      },
      {
        validators: this.maxLeaveBalanceCapValidator
      }
    )

    // this.updateform = this.fb.group({
    //   title: ['', [Validators.required]], // Example validators
    //   description: [''], // Example validators
    //   disabled: [false],

    //   date: ['', [Validators.required]], // Example validators
    //   leaveType: ['', Validators.required],
    //   businessId: ['', Validators.required],
    //   // effectiveFrom: ['', Validators.required],
    //   encashable: [false, Validators.required],

    //   accrualMethod: ['Throughout Every Period', Validators.required],
    //   totalPerYear: [0, [Validators.required, Validators.max(365), Validators.min(0)]],
    //   accrualFrequency: ['Annually'],
    //   accrualHappenPeriod: [false],
    //   isProbationPeriod: [false],
    //   probationPeriodLength: [0, [Validators.required, Validators.min(0)]],
    //   maxLeaveBalanceCap: [false],
    //   accruedProRataBasis: [false],

    //   resetHappen: ['Annually', Validators.required],
    //   resetStart: ['January', Validators.required],
    //   resetHappenPeriod: [true, Validators.required],
    //   leavesCarryForward: [0, [Validators.required, Validators.max(365), Validators.min(0)]],
    //   futureResetCycle: [false, Validators.required],

    //   leaveAdvanceNoticePeriod: [false, Validators.required],
    //   leaveAdvanceNoticePeriodDay: [
    //     0,
    //     [Validators.required, Validators.max(365), Validators.min(0)]
    //   ],
    //   isHalfDay: [false, Validators.required],
    //   isQuarterDay: [false, Validators.required],
    //   maxConsecutiveLeaves: [0, [Validators.required, Validators.max(365), Validators.min(0)]],
    //   isHolidayExcluded: [false, Validators.required],
    //   isWeekendExcluded: [false, Validators.required],
    //   isNagativeBalanceAllowed: [false, Validators.required],
    //   leaveTypeExclude: this.fb.control([])
    // })

    this.updateform = this.fb.group(
      {
        title: ['', [Validators.required]],
        description: [''],
        disabled: [false],

        date: ['', [Validators.required]],
        leaveType: ['', Validators.required],
        businessId: ['', Validators.required],
        encashable: [false],

        // ✅ removed Validators.required — can be null from DB
        accrualMethod: ['Throughout Every Period'],
        totalPerYear: [0, [Validators.max(365), Validators.min(0)]],
        accrualFrequency: ['Annually'],
        accrualHappenPeriod: [false],
        isProbationPeriod: [false],
        probationPeriodLength: [0, [Validators.min(0)]],
        maxLeaveBalanceCap: [0, [Validators.required, Validators.min(0), Validators.max(365)]],

        IsMaxLeaveBalanceCap: [false],
        accruedProRataBasis: [false],
        // maxLeaveBalance: [0, [Validators.min(0), Validators.max(365)]],

        resetHappen: ['Annually'],
        resetStart: ['January'],
        resetHappenPeriod: [true],
        leavesCarryForward: [0, [Validators.max(365), Validators.min(0)]],
        futureResetCycle: [false],

        leaveAdvanceNoticePeriod: [false],
        leaveAdvanceNoticePeriodDay: [0, [Validators.max(365), Validators.min(0)]],
        isHalfDay: [false],
        isQuarterDay: [false],
        maxConsecutiveLeaves: [0, [Validators.max(365), Validators.min(0)]],
        isHolidayExcluded: [false],
        isWeekendExcluded: [false],
        isNagativeBalanceAllowed: [false],
        leaveTypeExclude: this.fb.control([])
      },
      {
        validators: this.maxLeaveBalanceCapValidator
      }
    )

    this.attachLeaveTypeWatcher()
  }

  //pagination
  onPageChange(page: number) {
    this.currentPage = page
    this.getLeavePolicyList()
  }

  //modal open
  openBusiness(content: unknown) {
    this.resetModalState()
    const modalRef = this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg'
    })
    modalRef.result.finally(() => {
      this.resetModalState()
    })
  }

  resetModalState() {
    this.currentStep = 1
    this.editPolicy = null
    this.isLoading = false
    this.hideOtherFields = false
    this.resetCreateForm()
    this.resetUpdateForm()
    this.assignLeavePolicyform.reset({
      employeeIds: [],
      leavePolicyId: '',
      businessId: ''
    })
    // this.policyList = []
    this.employeeList = []
    this.modalPolicyList = []
    this.selectedBusinessId = ''
    this.selectedBusiness = null
  }

  //modal close
  // onClose() {
  //   this.currentStep = 1
  //   this.modalService.dismissAll()
  //   // this.initializeForm()
  //   this.form.reset()
  //   this.hideOtherFields = false
  //   this.editPolicy = null
  //   this.updateform.reset()
  //   this.isLoading = false
  //   this.initializeForm()
  //   this.assignLeavePolicyform.reset()
  //   // this.policyList = []
  // }

  onClose() {
    this.modalService.dismissAll()
    this.resetModalState()
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }

    if (control?.hasError('min')) {
      return `Minimum value is ${control.errors?.['min']?.min}`
    }

    if (control?.hasError('max')) {
      return `Maximum value is ${control.errors?.['max']?.max}`
    }

    return null // No error
  }

  getUpdateFormErrorMessage(controlName: string): string | null {
    const control = this.updateform.get(controlName)

    if (!control || !control.touched || control.valid) return null

    if (control.hasError('required')) {
      return 'This field is required'
    }

    if (control.hasError('min')) {
      return `Minimum value is ${control.errors?.['min']?.min}`
    }

    if (control.hasError('max')) {
      return `Maximum value is ${control.errors?.['max']?.max}`
    }

    return 'Invalid value'
  }

  getLeavePolicyList() {
    this.isArchived = false
    //let skip = this.currentPage * this.pageLimit - this.pageLimit
    //const search = this.search
    //  ? {
    //      $or: { title: { $like: `%${this.search}%` } },
    //      $and: { businessId: { $like: `%${this.selectedBusiness}%` } }
    //    }
    //  : { businessId: { $like: `%${this.selectedBusiness}%` } }

    this.leavePolicyService
      .list(this.selectedBusiness!, this.search!, this.currentPage, this.pageLimit)
      .subscribe({
        next: response => {
          this.policyList = response.leavePolicies
          this.totalCount = response.totalCount
          this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
        },
        error: error => {
          this.toastr.error('Error: ' + error.error.message)
        }
      })
  }

  openBlockUnblock(content: unknown, id: string, title: string, status: string) {
    this.blockUnblockId = id
    this.blockTilte = title
    if (status === 'Active') {
      this.blockUnblockStatus = 'Inactive'
    } else if (status === 'Inactive') {
      this.blockUnblockStatus = 'Active'
    }

    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  confirmBlockUnblock() {
    if (this.blockUnblockId) {
      // Prepare the request body
      const requestBody = {
        status: this.blockUnblockStatus,
        id: this.blockUnblockId,
        title: this.blockTilte
      }

      this.leavePolicyService.update(this.blockUnblockId, requestBody).subscribe(res => {
        if (res.id) {
          this.toastr.success(
            'SUCCESS',
            'Leave Policy ' + this.blockUnblockStatus + ' successfully!'
          )
        }
      })
      this.getLeavePolicyList()
      this.onClose()
    }
  }

  openDelete(content: unknown, id: string) {
    this.DeleteId = id
    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  confirmDelete() {
    if (this.DeleteId) {
      this.leavePolicyService.delete(this.DeleteId).subscribe(() => {
        this.toastr.success('SUCCESS', 'Leave Policy deleted successfully!')
      })
      this.getLeavePolicyList()
      this.onClose()
    }
  }

  openEditPolicy(content: unknown, policy: LeavePolicy) {
    this.currentStep = 1
    this.hideOtherFields = false
    this.editPolicy = policy
    this.updateform.get('title')?.setValue(policy.title)
    this.updateform.get('date')?.setValue(policy.date)
    this.updateform.get('description')?.setValue(policy.description)
    this.updateform.get('businessId')?.setValue(policy.businessId)
    this.updateform.get('leaveType')?.setValue(policy.leaveType)
    this.updateform.get('disabled')?.setValue(policy.disabled)
    this.updateform.get('encashable')?.setValue(policy.encashable)
    // console.log({
    //   policyLeaveType: policy.leaveType,
    //   policyLeaveTypeType: typeof policy.leaveType,
    //   enumCompOff: this.leaveTypeEnum.COMPOFF,
    //   enumCompOffType: typeof this.leaveTypeEnum.COMPOFF
    // })

    // if (
    //   policy.leaveType === this.leaveTypeEnum.COMPOFF ||
    //   policy.leaveType === this.leaveTypeEnum.LEAVEWITHOUTPAY
    // ) {
    //   this.hideOtherFields = true
    //   this.updateform.get('accrualMethod')?.setValue('Unlimited')
    //   this.updateform.get('totalPerYear')?.setValue(0)
    //   this.updateform.get('accrualMethod')?.disable()
    //   this.updateform.get('totalPerYear')?.disable()
    // } else {
    //   this.updateform.get('accrualMethod')?.enable()
    //   this.updateform.get('totalPerYear')?.enable()
    //   this.updateform
    //     .get('accrualMethod')
    //     ?.setValue(policy.accrualMethod ?? 'Throughout Every Period')
    //   this.updateform.get('totalPerYear')?.setValue(policy.totalPerYear ?? 0)
    // }

    if (
      policy.leaveType === this.leaveTypeEnum.COMPOFF ||
      policy.leaveType === this.leaveTypeEnum.LEAVEWITHOUTPAY
    ) {
      // this.hideOtherFields = true
      this.updateform.get('accrualMethod')?.setValue(policy.accrualMethod || 'Unlimited')
      this.updateform.get('totalPerYear')?.setValue(policy.totalPerYear || 0)
      this.updateform.get('accrualMethod')?.enable()
      this.updateform.get('totalPerYear')?.enable()
    } else {
      this.updateform.get('accrualMethod')?.enable()
      this.updateform.get('totalPerYear')?.enable()
      this.updateform
        .get('accrualMethod')
        ?.setValue(policy.accrualMethod || 'Throughout Every Period')
      this.updateform.get('totalPerYear')?.setValue(policy.totalPerYear ?? 0)
    }
    // this.updateform.get('accrualMethod')?.setValue(policy.accrualMethod)
    this.updateform.get('totalPerYear')?.setValue(policy.totalPerYear)
    this.updateform.get('accrualFrequency')?.setValue(policy.accrualFrequency)
    this.updateform.get('accrualHappenPeriod')?.setValue(policy.accrualHappenPeriod)
    this.updateform.get('isProbationPeriod')?.setValue(policy.isProbationPeriod)
    this.updateform.get('probationPeriodLength')?.setValue(policy.probationPeriodLength)

    this.updateform.get('IsMaxLeaveBalanceCap')?.setValue(policy.IsMaxLeaveBalanceCap)
    this.updateform.get('maxLeaveBalanceCap')?.setValue(policy.maxLeaveBalanceCap ?? 0)
    this.updateform.get('accruedProRataBasis')?.setValue(policy.accruedProRataBasis)
    this.updateform.get('proRataBasisDays')?.setValue(policy.proRataBasisDays ?? 0)

    this.updateform.get('resetHappen')?.setValue(policy.resetHappen)
    this.updateform.get('resetStart')?.setValue(policy.resetStart)
    this.updateform.get('resetHappenPeriod')?.setValue(policy.resetHappenPeriod)
    this.updateform.get('leavesCarryForward')?.setValue(policy.leavesCarryForward)
    this.updateform.get('futureResetCycle')?.setValue(policy.futureResetCycle)
    // this.updateform.get('maxLeaveBalance')?.setValue(policy.maxLeaveBalance ?? 0)

    this.updateform.get('leaveAdvanceNoticePeriod')?.setValue(policy.leaveAdvanceNoticePeriod)
    this.updateform.get('leaveAdvanceNoticePeriodDay')?.setValue(policy.leaveAdvanceNoticePeriodDay)
    this.updateform.get('isHalfDay')?.setValue(policy.isHalfDay)
    this.updateform.get('isQuarterDay')?.setValue(policy.isQuarterDay)
    this.updateform.get('maxConsecutiveLeaves')?.setValue(policy.maxConsecutiveLeaves)
    this.updateform.get('isHolidayExcluded')?.setValue(policy.isHolidayExcluded)
    this.updateform.get('isWeekendExcluded')?.setValue(policy.isWeekendExcluded)
    this.updateform.get('isNagativeBalanceAllowed')?.setValue(policy.isNagativeBalanceAllowed)
    this.updateform.get('leaveTypeExclude')?.setValue(policy.leaveTypeExclude)

    this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })
  }
  // onSubmit() {
  //     // console.log('update form validation', this.updateform.valid)

  //     if (this.form.valid || this.updateform.valid) {
  //       this.isLoading = true
  //       // Handle form submission
  //       // console.log(this.form.value);
  //       const formData = {
  //         ...this.form.value // Spread the form values
  //         // businessId: this.businessId, // Add the businessId
  //       }

  //       if (!this.editPolicy && this.form.valid) {
  //         console.log('Submitting formData:', JSON.stringify(this.form.value, null, 2))
  //         this.leavePolicyService.create(formData).subscribe({
  //           next: () => {
  //             this.isLoading = false
  //             this.toastr.success('SUCCESS', 'Leave Policy created successfully!')
  //             this.getLeavePolicyList()
  //             this.onClose()

  //             // console.log('modal closed');
  //           },
  //           error: (error: any) => {
  //             this.isLoading = false

  //             this.toastr.error('Error: ' + error.error.message)
  //           }
  //         })
  //       } else if (this.editPolicy && this.updateform.valid) {
  //         // console.log('update form')
  //         const formData = {
  //           ...this.updateform.value // Spread the form values
  //           // businessId: this.businessId, // Add the businessId
  //         }
  //         this.leavePolicyService.update(this.editPolicy.id, formData).subscribe({
  //           next: () => {
  //             this.isLoading = false
  //             this.toastr.success('SUCCESS', 'Leave Policy updated successfully!')
  //             this.getLeavePolicyList()
  //             this.onClose()
  //             this.editPolicy = null

  //             // console.log('modal closed');
  //           },
  //           error: (error: any) => {
  //             this.isLoading = false

  //             this.toastr.error('Error: ' + error.error.message)
  //           }
  //         })
  //       }
  //     } else {
  //       // Mark all controls as touched to trigger validation error display
  //       this.form.markAllAsTouched()
  //     }
  //   }

  // This code is written by SHIVAM
  // onSubmit() {
  //     if (this.form.valid || this.updateform.valid) {
  //       this.isLoading = true

  //       if (!this.editPolicy && this.form.valid) {

  //         // ✅ FIX 1: Applied here for CREATE
  //         const formData = {
  //           ...this.form.value,
  //           accrualMethod: this.form.value.accrualMethod ?? '',
  //           leaveTypeExclude: this.form.value.leaveTypeExclude?.length
  //             ? this.form.value.leaveTypeExclude
  //             : null  // 👈 converts [] to null
  //         }

  //         console.log('Submitting formData:', JSON.stringify(formData, null, 2))
  //         this.leavePolicyService.create(formData).subscribe({
  //           next: () => {
  //             this.isLoading = false
  //             this.toastr.success('SUCCESS', 'Leave Policy created successfully!')
  //             this.getLeavePolicyList()
  //             this.onClose()
  //           },
  //           error: (error: any) => {
  //             this.isLoading = false
  //             console.error('Backend says:', error.error) // 👈 add this for debugging
  //             this.toastr.error('Error: ' + error.error.message)
  //           }
  //         })

  //       } else if (this.editPolicy && this.updateform.valid) {

  //         const formData = {
  //           ...this.updateform.value,
  //           leaveTypeExclude: this.updateform.value.leaveTypeExclude?.length
  //             ? this.updateform.value.leaveTypeExclude
  //             : null  // 👈 converts [] to null
  //         }

  //         this.leavePolicyService.update(this.editPolicy.id, formData).subscribe({
  //           next: () => {
  //             this.isLoading = false
  //             this.toastr.success('SUCCESS', 'Leave Policy updated successfully!')
  //             this.getLeavePolicyList()
  //             this.onClose()
  //             this.editPolicy = null
  //           },
  //           error: (error: any) => {
  //             this.isLoading = false
  //             console.error('Backend says:', error.error) // 👈 add this for debugging
  //             this.toastr.error('Error: ' + error.error.message)
  //           }
  //         })
  //       }

  //     } else {
  //       this.form.markAllAsTouched()
  //     }
  //   }

  onSubmit() {
    if (!this.validateResetFrequency()) {
      this.toastr.error('Invalid reset frequency selected according to accrual frequency')
      return
    }

    const isUpdating = !!this.editPolicy

    // ✅ Check the correct form based on mode
    const activeForm = isUpdating ? this.updateform : this.form

    if (activeForm.valid) {
      this.isLoading = true

      if (!isUpdating) {
        // CREATE
        // const formData = {
        //   ...this.form.value,
        //   accrualMethod: this.form.value.accrualMethod ?? '',
        //   leaveTypeExclude: this.form.value.leaveTypeExclude?.length
        //     ? this.form.value.leaveTypeExclude
        //     : null
        // }

        const formData = {
          ...this.form.value,
          accrualMethod: this.form.value.accrualMethod || 'Throughout Every Period',
          leaveTypeExclude: this.form.value.leaveTypeExclude?.length
            ? this.form.value.leaveTypeExclude
            : null
        }

        // console.log('Creating:', JSON.stringify(formData, null, 2))
        this.leavePolicyService.create(formData).subscribe({
          next: () => {
            this.isLoading = false
            this.toastr.success('SUCCESS', 'Leave Policy created successfully!')
            this.getLeavePolicyList()
            this.onClose()
          },
          error: (error: any) => {
            this.isLoading = false
            // console.error('Backend says:', error.error)
            this.onClose()
            this.toastr.error('Error: ' + error.error.message)
          }
        })
      } else {
        // UPDATE
        const formData = {
          ...this.updateform.value,
          // accrualMethod: this.updateform.value.accrualMethod ?? '',
          // leaveTypeExclude: this.updateform.value.leaveTypeExclude?.length

          accrualMethod: this.updateform.value.accrualMethod ?? 'Throughout Every Period',
          totalPerYear: this.updateform.value.totalPerYear ?? 0,
          probationPeriodLength: this.updateform.value.probationPeriodLength ?? 0,
          leavesCarryForward: this.updateform.value.leavesCarryForward ?? 0,
          leaveAdvanceNoticePeriodDay: this.updateform.value.leaveAdvanceNoticePeriodDay ?? 0,
          maxConsecutiveLeaves: this.updateform.value.maxConsecutiveLeaves ?? 0,
          leaveTypeExclude: this.updateform.value.leaveTypeExclude?.length
            ? this.updateform.value.leaveTypeExclude
            : null
        }

        // console.log('Updating:', JSON.stringify(formData, null, 2))
        this.leavePolicyService.update(this.editPolicy!.id, formData).subscribe({
          next: () => {
            this.isLoading = false
            this.toastr.success('SUCCESS', 'Leave Policy updated successfully!')
            this.getLeavePolicyList()
            this.onClose()
            this.editPolicy = null
          },
          error: (error: any) => {
            this.isLoading = false
            // console.error('Backend says:', error.error)
            this.toastr.error('Error: ' + error.error.message)
          }
        })
      }
    } else {
      // ✅ Mark the correct form as touched to show validation errors
      activeForm.markAllAsTouched()
      this.onClose()
      // console.log('Form invalid:', activeForm.errors, activeForm.value)
    }
  }
  onAssign() {
    if (this.assignLeavePolicyform.valid) {
      // Handle form submission
      // console.log(this.form.value);
      const formData = {
        ...this.assignLeavePolicyform.value // Spread the form values
        // businessId: this.businessId, // Add the businessId
      }
      if (!this.editPolicy) {
        const rawForm = this.assignLeavePolicyform.getRawValue()

        const formData = {
          employeeIds: rawForm.employeeIds,
          leavePolicyId: rawForm.leavePolicyId
        }
        this.leavePolicyService.assignPolicy(formData).subscribe({
          next: () => {
            this.toastr.success('SUCCESS', 'Leave Policy assigned successfully!')
            this.getLeavePolicyList()
            this.onClose()
            // console.log('modal closed');
          },
          error: (error: any) => {
            this.toastr.error('Error: ' + error.error.message)
          }
        })
      } else if (this.editPolicy) {
        this.leavePolicyService.update(this.editPolicy.id, formData).subscribe({
          next: () => {
            this.toastr.success('SUCCESS', 'Leave Policy updated successfully!')
            this.getLeavePolicyList()
            this.onClose()
            this.editPolicy = null
            // console.log('modal closed');
          },
          error: error => {
            this.toastr.error('Error: ' + error.error.message)
          }
        })
      }
    } else {
      // Mark all controls as touched to trigger validation error display
      this.form.markAllAsTouched()
    }
  }

  getBusinessName(businessId: string | undefined): string | undefined {
    if (!businessId) return ''
    return this.businessList?.find(b => b.id === businessId)?.businessName
  }

  handleSortChange(event: Event): void {
    const target = event.target as HTMLSelectElement // Cast to HTMLSelectElement
    this.selectedBusiness = target.value // Access the value
    this.getLeavePolicyList() // Call your function
  }

  get employeeIds(): FormArray {
    return this.assignLeavePolicyform.get('employeeIds') as FormArray
  }

  onEmployeeSelect(event: Event) {
    const selectedOptions = (event.target as HTMLSelectElement).selectedOptions
    this.employeeIds.clear()

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < selectedOptions.length; i++) {
      const value = selectedOptions[i].value
      this.employeeIds.push(this.fb.control(value, Validators.required))
    }

    this.employeeIds.markAsTouched()
    this.employeeIds.updateValueAndValidity()
  }

  onChangePolicyList(target: EventTarget | null) {
    this.employeeList = []
    // this.policyList = []
    this.modalPolicyList = []
    this.assignLeavePolicyform.get('employeeIds')?.setValue([])
    this.assignLeavePolicyform.get('leavePolicyId')?.setValue('')
    if (target instanceof HTMLSelectElement) {
      if (target.value) {
        this.selectedBusiness = target.value

        this.selectedBusinessId = target.value
        this.isArchived = false
        //let skip = this.currentPage * this.pageLimit - this.pageLimit
        //const search = this.search
        //  ? { $or: { businessId: { $like: `%${selectedBusinessId}%` } } }
        //  : { businessId: { $like: `%${selectedBusinessId}%` } }

        this.leavePolicyService
          .list(this.selectedBusiness!, this.search, this.currentPage, this.pageLimit)
          .subscribe({
            next: response => {
              // console.log('business', response.rows)
              // this.policyList = response.leavePolicies
              this.modalPolicyList = response.leavePolicies
              // this.totalCount = response.count;
            },
            error: error => {
              this.toastr.error('Error: ' + error.error.message)
            }
          })
      }
    } else {
      this.leavePolicyService
        .list(this.selectedBusinessId!, this.search, this.currentPage, this.pageLimit)
        .subscribe({
          next: response => {
            // console.log('business', response.rows)
            // this.policyList = response.leavePolicies
            this.modalPolicyList = response.leavePolicies
            // this.totalCount = response.count;
          },
          error: error => {
            this.toastr.error('Error: ' + error.error.message)
          }
        })
    }
  }

  onChangeEmployeeList(target: EventTarget | null) {
    this.employeeList = []
    this.assignLeavePolicyform.get('employeeIds')?.setValue([])
    if (target instanceof HTMLSelectElement) {
      if (target.value) {
        // const selectedBusinessId = target.value;
        this.isArchived = false
        const params = `businessId=${encodeURIComponent(this.selectedBusinessId)}&disabled=false`
        const isEmployeeActive = true
        forkJoin({
          policyAssigned: this.leavePolicyService.assignedPolicyList(
            this.selectedBusinessId!,
            target.value,
            this.currentPage,
            this.pageLimit,
            isEmployeeActive
          ),
          employeeList: this.userService.getEmployees(params)
        }).subscribe({
          next: ({ policyAssigned, employeeList }) => {
            const policyAssignedEmployeeIds = new Set(
              policyAssigned.assignedLeavePolicies.map((user: { userId: unknown }) => user.userId)
            )
            // Filter employees who are not in the assigned policies
            this.employeeList = employeeList.users.filter(
              (user: { id: unknown }) => !policyAssignedEmployeeIds.has(user.id)
            )

            // Optionally, update total count if needed
            // this.totalCount = this.employeeList.length;
          },
          error: error => {
            this.toastr.error('Error: ' + error.error.message)
          }
        })
      }
    }
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.getLeavePolicyList() // Load employees with new page limit
  }

  loadEmployees() {
    const params: any = {}
    if (this.businessIdss?.length) {
      params.businessIds = this.businessIdss.join(',')
    }
    // console.log('business ids', this.businessIdss)
    // if (this.search) {
    //   params.firstName = this.search
    // }

    // if (this.businessId) {
    //   params.businessId = this.businessId
    // }

    this.store.dispatch(
      loadEmployees({
        params: new URLSearchParams(params).toString()
      })
    )
  }
  onBusinessChange(businessId: string) {
    if (businessId) {
      const control = this.form.get('businessId')
      control?.setValue(businessId)
      control?.markAsDirty()
      control?.markAsTouched()
      control?.updateValueAndValidity()

      this.selectedBusinessId = businessId
      // Call a method to fetch data based on the selected owner
      const params = `businessId=${encodeURIComponent(businessId)}`

      // this.store.dispatch(loadDepartments({ params })) // Dispatch action with filter
    } else {
      const params = ''
      // this.store.dispatch(loadDepartments({ params })) // Dispatch action with filter
      // Handle the case where no owner is selected
      // console.log('No business selected')
    }
  }

  loadAllBusinesses() {
    const params: any = {}
    if (this.businessIdss?.length) {
      params.businessIds = this.businessIdss.join(',')
    }
    params.disabled = false

    this.store.dispatch(
      loadBusinesses({
        params: new URLSearchParams(params).toString()
      })
    )
  }

  getDashboardRoute(): string {
    // return this.user?.role === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
    return this.utilsService.getDashboardRoute()
  }

  customSearchFn = (term: string, item: any) => {
    const fullName = `${item.businessName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  customSearchFnEmployee = (term: string, item: any) => {
    const fullName = `${item.firstName} ${item.lastName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  // Function to check if the current step is valid
  isStepValid() {
    const isUnlimitedLeave =
      this.form.get('leaveType')?.value === this.leaveTypeEnum.COMPOFF ||
      this.form.get('leaveType')?.value === this.leaveTypeEnum.LEAVEWITHOUTPAY
    switch (this.currentStep) {
      case 1:
        return (
          this.form.get('businessId')?.valid &&
          this.form.get('leaveType')?.valid &&
          this.form.get('title')?.valid &&
          this.form.get('date')?.valid &&
          this.form.get('description')?.valid
        )
      // return true
      case 2:
        // if (this.form.get('leaveType')?.value === this.leaveTypeEnum.COMPOFF) {
        if (isUnlimitedLeave) {
          return true // skip to step 4 for COMPOFF
        }

        // return this.form.get('accrualMethod')?.valid
        return (
          this.form.get('accrualMethod')?.valid &&
          this.form.get('maxLeaveBalanceCap')?.valid &&
          !this.form.hasError('maxLeaveBalanceCapLessThanTotalPerYear')
        )
      // return true
      case 3:
        // return (
        //   this.form.get('isSingleClockIn')?.valid &&
        //   this.form.get('defineValidClock')?.valid &&
        //   this.form.get('isMinimumWorkHours')?.valid &&
        //   this.form.get('workDayExtensionMinutes')?.valid &&
        //   this.form.get('firstClockInAfterTime')?.valid &&
        //   this.form.get('isSelfie')?.valid
        // )
        return true
      case 4:
        // return (
        //   this.form.get('isSingleClockIn')?.valid &&
        //   this.form.get('defineValidClock')?.valid &&
        //   this.form.get('isMinimumWorkHours')?.valid &&
        //   this.form.get('workDayExtensionMinutes')?.valid &&
        //   this.form.get('firstClockInAfterTime')?.valid &&
        //   this.form.get('isSelfie')?.valid
        // )
        return true
      case 5:
        // return (
        //   this.form.get('isSingleClockIn')?.valid &&
        //   this.form.get('defineValidClock')?.valid &&
        //   this.form.get('isMinimumWorkHours')?.valid &&
        //   this.form.get('workDayExtensionMinutes')?.valid &&
        //   this.form.get('firstClockInAfterTime')?.valid &&
        //   this.form.get('isSelfie')?.valid
        // )
        return true
      default:
        return false
    }
  }

  // Function to go to the next step
  // goToNextStep(): void {
  //   if (this.isStepValid()) {
  //     this.currentStep++
  //   } else if (this.isUpdateStepValid()) {
  //     this.currentStep++
  //   } else {
  //     alert('Please complete the form before proceeding!')
  //   }
  // }

  // goToNextStep(): void {
  //   if (this.isStepValid() || this.isUpdateStepValid()) {
  //     if (this.currentStep === 2 && this.hideOtherFields) {
  //       this.currentStep = 4
  //     } else {
  //       this.currentStep++
  //     }
  //   } else {
  //     alert('Please complete the form before proceeding!')
  //   }
  // }

  goToNextStep(): void {
    if (this.currentStep === 2 || this.currentStep === 3 || this.currentStep === 4) {
      if (!this.validateResetFrequency()) {
        this.toastr.error('Reset frequency cannot be greater than accrual frequency')
        return
      }
    }

    // if (this.isStepValid() || this.isUpdateStepValid()) {
    //   if (this.currentStep === 2 && this.hideOtherFields) {
    //     this.currentStep = 4
    //   } else {
    //     this.currentStep++
    //   }
    // } else {
    //   alert('Please complete the form before proceeding!')
    // }
    if (this.isStepValid() || this.isUpdateStepValid()) {
      this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  stepChange(newStep: number): void {
    if (this.isStepValid() || this.isUpdateStepValid()) {
      this.currentStep = newStep
    }
    // else if (this.isUpdateStepValid()) {
    //   this.currentStep++
    // }
    else {
      alert('Please complete the form before proceeding!')
    }
  }

  setAsDefault(policy: any) {
    this.leavePolicyService.setDefaultPolicy(policy.id).subscribe({
      next: res => {
        this.toastr.success(res.message) // ✅ Show backend-provided success message
        this.getLeavePolicyList() // 🔄 Refresh leave policy list
      },
      error: err => {
        // console.error('Failed to set default policy', err)
        this.toastr.error(err?.error?.message || 'Something went wrong while updating the policy.') // ❌ Show meaningful error toast
      }
    })
  }

  isAdmin(): boolean {
    // return this.user?.role === 'Admin'
    return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Admin') ?? false
  }

  formatDateToYYYYMMDD(date: any): string {
    const d = new Date(date)
    return d.toISOString().split('T')[0]
  }

  onChangeBusinessPolicyList() {
    this.leavePolicyService.list(this.selectedBusinessId ?? '').subscribe(res => {
      this.modalPolicyList = res.attendancePolicies
    })
  }

  isUpdateStepValid() {
    switch (this.currentStep) {
      case 1:
        return this.updateform.get('title')?.valid && this.updateform.get('description')?.valid
      // return true
      // case 2:
      //   return this.updateform.get('accrualMethod')?.valid
      case 2:
        const accrualCtrl = this.updateform.get('accrualMethod')
        const totalCtrl = this.updateform.get('totalPerYear')
        const maxLeaveBalanceCtrl = this.updateform.get('maxLeaveBalanceCap')

        return (
          accrualCtrl?.valid &&
          (accrualCtrl.value === 'unlimited' || totalCtrl?.valid) &&
          maxLeaveBalanceCtrl?.valid &&
          !this.updateform.hasError('maxLeaveBalanceCapLessThanTotalPerYear')
        )
      // return true
      case 3:
        return true
      case 4:
        return true
      case 5:
        return true
      default:
        return false
    }
  }

  private resetCreateForm(): void {
    this.form.reset({
      title: '',
      date: '',
      description: '',
      leaveType: '',
      disabled: false,
      businessId: '',
      encashable: false,

      accrualMethod: 'Throughout Every Period',
      totalPerYear: 0,
      accrualFrequency: 'Annually',
      accrualHappenPeriod: false,
      isProbationPeriod: false,
      probationPeriodLength: 0,
      maxLeaveBalanceCap: 0,
      IsMaxLeaveBalanceCap: false,
      accruedProRataBasis: false,
      proRataBasisDays: 0,

      resetHappen: 'Annually',
      resetStart: 'January',
      resetHappenPeriod: true,
      leavesCarryForward: 0,
      futureResetCycle: false,

      leaveAdvanceNoticePeriod: false,
      leaveAdvanceNoticePeriodDay: 0,
      isHalfDay: false,
      isQuarterDay: false,
      maxConsecutiveLeaves: 0,
      isHolidayExcluded: false,
      isWeekendExcluded: false,
      isNagativeBalanceAllowed: false,
      leaveTypeExclude: []
    })

    this.form.enable()

    this.hideOtherFields = false
  }

  private resetUpdateForm(): void {
    this.updateform.reset({
      title: '',
      date: '',
      description: '',
      leaveType: '',
      disabled: false,
      businessId: '',
      encashable: false,

      accrualMethod: 'Throughout Every Period',
      totalPerYear: 0,
      accrualFrequency: 'Annually',
      accrualHappenPeriod: false,
      isProbationPeriod: false,
      probationPeriodLength: 0,
      maxLeaveBalanceCap: 0,
      IsMaxLeaveBalanceCap: false,
      accruedProRataBasis: false,
      proRataBasisDays: 0,

      resetHappen: 'Annually',
      resetStart: 'January',
      resetHappenPeriod: true,
      leavesCarryForward: 0,
      futureResetCycle: false,

      leaveAdvanceNoticePeriod: false,
      leaveAdvanceNoticePeriodDay: 0,
      isHalfDay: false,
      isQuarterDay: false,
      maxConsecutiveLeaves: 0,
      isHolidayExcluded: false,
      isWeekendExcluded: false,
      isNagativeBalanceAllowed: false,
      leaveTypeExclude: []
    })

    this.updateform.enable()

    this.hideOtherFields = false
  }

  validateResetFrequency(): boolean {
    const accrual = this.form.get('accrualFrequency')?.value
    const reset = this.form.get('resetHappen')?.value
    const allowedResetMap: Record<string, string[]> = {
      Monthly: ['Monthly', 'Quaterly', 'HalfYearly', 'Annually'],

      Quaterly: ['Quaterly', 'HalfYearly', 'Annually'],

      HalfYearly: ['HalfYearly', 'Annually'],

      Annually: ['Annually']
    }

    return allowedResetMap[accrual]?.includes(reset) ?? false
  }

  maxLeaveBalanceCapValidator(control: AbstractControl): ValidationErrors | null {
    const isCapEnabled = control.get('IsMaxLeaveBalanceCap')?.value
    const totalPerYear = control.get('totalPerYear')?.value
    const maxLeaveBalanceCap = control.get('maxLeaveBalanceCap')?.value

    if (!isCapEnabled) {
      return null
    }

    if (
      totalPerYear === null ||
      totalPerYear === undefined ||
      maxLeaveBalanceCap === null ||
      maxLeaveBalanceCap === undefined
    ) {
      return null
    }

    if (Number(maxLeaveBalanceCap) < Number(totalPerYear)) {
      return {
        maxLeaveBalanceCapLessThanTotalPerYear: true
      }
    }

    return null
  }
}
